import axios from "axios";
import moment from "moment";

export const getFileExtension = (url) => {
  // Get the last part of the URL after the last '/'
  const filename = url.substring(url.lastIndexOf("/") + 1);

  // Get the file extension by getting the last part of the filename after the last '.'
  const extension = filename.substring(filename.lastIndexOf(".") + 1);

  return extension;
};

export const isObjectEmpty = (obj) => {
  for (const key in obj) {
    if (obj[key]) {
      if (obj[key] === '{"min":0,"max":20000000}') {
      } else {
        return false;
      }
    }
  }
  return true;
};

export const removeNullValues = (obj) => {
  for (const key in obj) {
    if (obj[key] === null) {
      delete obj[key];
    }
  }
  return obj;
};

export const getEmotions = () => {
  return [
    "Fear",
    "Anxiety",
    "Joy",
    "Love",
    "Sadness",
    "Anger",
    "Confusion",
    "Excitement",
    "Embarrassment",
    "Relief",
    "Curiosity",
    "Helplessness",
    "Guilt",
    "Longing",
    "Awe",
    "Peace",
    "Empowerment",
    "Nostalgia",
    "Frustration",
    "Shock",
    "Happy",
    "Sad",
    "Excited",
    "Scared",
  ];
};

export const getEmotionType = () => {
  return [
    "Ordinary Dream",
    "Lucid Dream",
    "Nightmare",
    "Night Terror",
    "Recurring Dream",
    "Day Residue Dream",
    "Prophetic or Precognitive Dream",
    "False Awakening Dream",
    "Epic or Vivid Dream",
    "Healing or Transformative Dream",
    "Flying or Falling Dream",
    "Abstract Dream",
    "Sexual Dream",
  ];
};

// ---------- Convert second to hours -----------
export const convertSecondToHours = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;
  return `${hours}h ${minutes}m ${remainingSeconds}s`;
};

// ------------- Get location details-----------
// export async function getLocationDetails(lat, lng) {
//   try {
//     const res = await fetch(
//       `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`
//     );
//     const data = await res.json();
//     return {
//       latitude: lat,
//       longitude: lng,
//       city: data.address.city || data.address.town,
//       country: data.address.country,
//       countryCode: data.address.country_code?.toUpperCase(),
//     };
//   } catch (err) {
//     console.error("Error fetching location details:", err);
//     return null;
//   }
// }

export async function getLocationDetails(lat, lng) {
  try {
    const res = await fetch("https://ipapi.co/json/");
    const data = await res.json();

    return {
      latitude: data.latitude,
      longitude: data.longitude,
      city: data.city,
      country: data.country_name,
      country_code: data.country_code,
    };
  } catch (err) {
    console.error("Error fetching location details:", err);
    return null;
  }
}

// Get diiferece with created and current date and time
export const getDifference = (createdDateTime) => {
  const createDate = moment(createdDateTime);
  const currentDate = moment();
  const duration = moment.duration(currentDate.diff(createDate));
  const years = duration.years();
  const months = duration.months();
  const days = duration.days();
  const hours = duration.hours();
  const minute = duration.minutes();
  let result = " ";

  if (hours === 0 && minute === 0) {
    return (result = `just now`);
  }

  if (hours === 0 && minute > 0) {
    result = `${minute} min`;
  }

  if (hours > 0 && years === 0) {
    result = `${hours} h`;
  }

  if (days > 0 && years === 0) {
    result = `${days} d `;
  }

  if (months > 0) {
    result = `${months} month `;
  }

  if (years > 0) {
    result = `${years} y `;
  }

  return `${result} ago`;
};

// ------------- Get system info like os, browser, device, etc. -----------
export const getSystemInfo = async () => {
  const device = navigator.userAgent;
  const platform = "Web";
  const deviceID = device.split(" ")[0];
  const deviceName = device.split(" ")[1];
  const deviceType = device.split(" ")[2];

  let location = null;

  if ("geolocation" in navigator) {
    location = await new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          const details = await getLocationDetails(latitude, longitude);
          resolve(details);
        },
        (error) => {
          console.error("Error getting location:", error);
          resolve(null);
        },
      );
    });
  }

  const systemInfo = {
    deviceID,
    deviceName,
    deviceType,
    platform,
    location,
  };
  return systemInfo;
};

// --------------- Get coordinates --------------
//  Async function to get latitude & longitude
export async function getCoordinates() {
  async function getIpBasedCoordinates() {
    try {
      const res = await fetch("https://ipapi.co/json/");
      const data = await res.json();
      if (data && data.latitude && data.longitude) {
        return { latitude: data.latitude, longitude: data.longitude };
      }
    } catch (e) {
      console.error("IP-based geolocation failed:", e);
    }
    return null;
  }

  const canUseBrowserGeolocation =
    "geolocation" in navigator && (window?.isSecureContext ?? false);

  if (canUseBrowserGeolocation) {
    try {
      const position = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
          (pos) => resolve(pos),
          (err) => reject(err),
          { enableHighAccuracy: true, timeout: 10000, maximumAge: 300000 },
        );
      });

      return {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
      };
    } catch (error) {
      console.error("Error getting coordinates:", error);
      // Fall through to IP-based geolocation
    }
  } else {
    if (!("geolocation" in navigator)) {
      console.error("Geolocation is not supported by this browser.");
    } else if (!(window?.isSecureContext ?? false)) {
      console.warn(
        "Geolocation requires a secure context (HTTPS). Falling back to IP-based lookup.",
      );
    }
  }

  // Fallback when HTTPS is not available or user blocks precise location
  return await getIpBasedCoordinates();
}

// ------------- Generate unique customer token ------------------
export function generateUniqueCustomerToken(minLength = 8, maxLength = 18) {
  // Get timestamp in milliseconds (13 digits, unique to ms)
  const timestamp = Date.now().toString(); // e.g. "1758950735123"

  // Generate secure random values
  const array = new Uint32Array(10);
  window.crypto.getRandomValues(array);

  let randomDigits = "";
  for (let i = 0; i < array.length; i++) {
    randomDigits += (array[i] % 10).toString();
  }

  // Combine timestamp + random digits
  let token = timestamp + randomDigits;

  // Trim if too long
  if (token.length > maxLength) {
    token = token.slice(0, maxLength);
  }

  // Pad with random digits if too short
  while (token.length < minLength) {
    token += Math.floor(Math.random() * 10).toString();
  }

  // Ensure it doesn’t start with 0
  if (token[0] === "0") {
    token = "9" + token.slice(1);
  }

  return token;
}

// ------------ U Payement function -------------
export async function uPayments(customerUniqueToken) {
  try {
    const response = await axios.post(
      "https://sandboxapi.upayments.com/api/v1/create-customer-unique-token",
      { customerUniqueToken: customerUniqueToken },
      {
        headers: {
          accept: "application/json",
          Authorization: "Bearer jtest123",
          "Content-Type": "application/json",
        },
      },
    );
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.error("Error when create u payment uniquecustomer:", error);
  }
}

// -------- add card function ------------
export async function addCard() {
  try {
    const response = await axios.post(
      "https://sandboxapi.upayments.com/api/v1/add-card",
      {
        customerUniqueToken: 546897254687954215,
        returnUrl: "https://webhook.site/d7c6e1c8-b98b-4f77-8b51-b487540df336",
      },
      {
        headers: {
          accept: "application/json",
          Authorization: "Bearer jtest123",
          "Content-Type": "application/json",
        },
      },
    );
    const link = response.data.data.link;
    window.open(link, "_blank");
  } catch (error) {
    console.error("❌ Error in addCard:", error.response?.data || error);
  }
}

// --------- charge card function -------------
export async function chargePayment(data) {
  try {
    const response = await axios.post(
      "https://sandboxapi.upayments.com/api/v1/charge",
      data,
      {
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer jtest123",
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error("❌ Error charging payment:", error.response?.data || error);
  }
}

// ---------- verify url -------------
export function isValidUrl(url) {
  try {
    new URL(url);
    return true;
  } catch (e) {
    return false;
  }
}

// --------- make capitlize ---------
export function toCapitalize(str) {
  return str?.charAt(0)?.toUpperCase() + str?.slice(1)?.toLowerCase();
}

// --------- Get difference in hours and minutes ----------
export const getDiff = (startDate, currentDate) => {
  startDate = moment(startDate);
  currentDate = moment(currentDate);

  const duration = moment.duration(startDate.diff(currentDate));

  if (duration.asSeconds() <= 0) {
    return "Live";
  }

  const days = Math.floor(duration.asDays());
  const hours = duration.hours();
  const minutes = duration.minutes();
  const seconds = duration.seconds();

  if (days > 0) {
    return `Starts in: ${days}d ${hours}h ${minutes}min ${seconds}s`;
  } else if (hours > 0) {
    return `Starts in: ${hours}h ${minutes}min ${seconds}s`;
  } else if (minutes > 0) {
    return `Starts in:  ${minutes}min ${seconds}s`;
  } else {
    return `Starts in:  ${seconds}s`;
  }
};

// --------- Get difference in hours and minutes ----------
export const getDiffInTwoDate = (startDate, endDate) => {
  startDate = moment(startDate);
  endDate = moment(endDate);

  const duration = moment.duration(startDate.diff(endDate));

  if (duration.asSeconds() <= 0) {
    return "Live";
  }

  const days = Math.floor(duration.asDays());
  const hours = duration.hours();
  const minutes = duration.minutes();
  const seconds = duration.seconds();

  if (days > 0) {
    return `${days}d left`;
  } else if (hours > 0) {
    return `${hours}s left`;
  } else if (minutes > 0) {
    return `${minutes}s left`;
  } else {
    return `${seconds}s left`;
  }
};

// ----------- Genrate UUID Function -------------
// deviceId.ts
const DEVICE_KEY = "app_device_id";

// ✅ Generate UUID (uses crypto if available, fallback otherwise)
function generateUUID() {
  if (crypto?.randomUUID) return crypto.randomUUID(); // Best option

  // Fallback UUID-ish generator
  return URL.createObjectURL(new Blob()).split("/").pop();
}

// ✅ Main function to get or create a persistent deviceId
export function getDeviceId() {
  // 1. Try localStorage
  let id = localStorage.getItem(DEVICE_KEY);
  if (id) return id;

  // 2. Try cookie fallback
  const match = document.cookie.match(
    new RegExp(`(?:^|; )${DEVICE_KEY}=([^;]*)`),
  );
  if (match) {
    id = decodeURIComponent(match[1]);
    localStorage.setItem(DEVICE_KEY, id);
    return id;
  }

  // 3. Nothing found → generate new deviceId
  id = generateUUID();

  // Save in localStorage
  localStorage.setItem(DEVICE_KEY, id);

  // Also save in cookie (to survive certain browser conditions)
  document.cookie = `${DEVICE_KEY}=${encodeURIComponent(
    id,
  )}; path=/; max-age=31536000; samesite=lax`;

  return id;
}

// ------------------- Streamining function ------------------
export const getChannelName = (streamLink) => {
  const twitchChannel = streamLink
    ?.replace("https://www.twitch.tv/", "")
    ?.split("/")[0];

  const kickChannel = streamLink
    ?.replace("https://kick.com/", "")
    .split("/")[0];

  return streamLink.includes("twitch.tv") ? twitchChannel : kickChannel;
};

// ------------- Get Podcast Audio Duration --------------
// export const getAudioDuration = (url) => {
//   return new Promise((resolve) => {
//     const audio = new Audio(url);

//     audio.addEventListener("loadedmetadata", () => {
//       const seconds = audio.duration;

//       if (!seconds || seconds <= 0) {
//         resolve("0 seconds");
//         return;
//       }

//       // 👉 Seconds
//       if (seconds < 60) {
//         resolve(`${Math.floor(seconds)} seconds`);
//         return;
//       }

//       // 👉 Minutes
//       if (seconds < 3600) {
//         const minutes = Math.round(seconds / 60);
//         resolve(minutes === 1 ? "1 minute" : `${minutes} minutes`);
//         return;
//       }

//       // 👉 Hours
//       const hours = Math.round(seconds / 3600);
//       resolve(hours === 1 ? "1 hour" : `${hours} hours`);
//     });

//     audio.addEventListener("error", () => resolve("0 seconds"));
//   });
// };

export const getAudioDuration = (url) => {
  const durationCache = {};
  return new Promise((resolve) => {
    if (!url) return resolve("0 seconds");

    // 🔥 Cached result return
    if (durationCache[url]) return resolve(durationCache[url]);

    const audio = new Audio();
    audio.src = url;
    audio.preload = "metadata";

    audio.addEventListener("loadedmetadata", () => {
      const seconds = audio.duration;

      let result = "0 seconds";

      if (seconds > 0) {
        if (seconds < 60) {
          result = `${Math.floor(seconds)} seconds`;
        } else if (seconds < 3600) {
          const minutes = Math.round(seconds / 60);
          result = minutes === 1 ? "1 minute" : `${minutes} minutes`;
        } else {
          const hours = Math.round(seconds / 3600);
          result = hours === 1 ? "1 hour" : `${hours} hours`;
        }
      }

      durationCache[url] = result; // ⭐ Save to cache
      resolve(result);
    });

    audio.addEventListener("error", () => {
      durationCache[url] = "0 seconds"; // cache this also
      resolve("0 seconds");
    });
  });
};

// --------- Shared pagination helpers ----------
export const DEFAULT_PAGE = 1;
export const DEFAULT_LIMIT = 10;

// Returns a pagination object with defaults applied and optional overrides.
export const getDefaultPagination = (overrides = {}) => ({
  page: DEFAULT_PAGE,
  limit: DEFAULT_LIMIT,
  ...overrides,
});

// Checks if a scrollable element is at (or near) the bottom.
export const isScrollAtBottom = (event, threshold = 1) => {
  const target = event?.target;
  if (!target) return false;
  return (
    target.scrollHeight - target.scrollTop <= target.clientHeight + threshold
  );
};
